export default "__VITE_ASSET__789271f5__"